import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from './ui/dialog';
import { Music, X } from 'lucide-react';

const SpotifyPlayer = () => {
  const [showPlayer, setShowPlayer] = useState(false);
  const [showConsentDialog, setShowConsentDialog] = useState(false);
  const [hasConsented, setHasConsented] = useState(false);

  // Spotify playlist embed URL
  const playlistUrl = "https://open.spotify.com/embed/playlist/4Lrer2cbFL3AmZrRWqCgs0?utm_source=generator&theme=0";

  useEffect(() => {
    // Controlla se l'utente ha già dato il consenso
    const consent = localStorage.getItem('tp_music_consent');
    
    if (consent === 'accepted') {
      setHasConsented(true);
      setShowPlayer(true);
    } else if (consent === 'declined') {
      setHasConsented(false);
      setShowPlayer(false);
    } else {
      // Prima visita - mostra dialog dopo 2 secondi
      const timer = setTimeout(() => {
        setShowConsentDialog(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('tp_music_consent', 'accepted');
    setHasConsented(true);
    setShowPlayer(true);
    setShowConsentDialog(false);
  };

  const handleDecline = () => {
    localStorage.setItem('tp_music_consent', 'declined');
    setShowConsentDialog(false);
  };

  const togglePlayer = () => {
    setShowPlayer(!showPlayer);
  };

  const closePlayer = () => {
    setShowPlayer(false);
    localStorage.setItem('tp_music_consent', 'declined');
    setHasConsented(false);
  };

  return (
    <>
      {/* Dialog di Consenso */}
      <Dialog open={showConsentDialog} onOpenChange={setShowConsentDialog}>
        <DialogContent className="bg-gray-900 border-red-600 border-2 max-w-md">
          <DialogTitle className="sr-only">Vuoi la musica?</DialogTitle>
          <DialogDescription className="sr-only">Attiva la playlist hip hop di sottofondo mentre navighi sul sito.</DialogDescription>
          <div className="text-center space-y-4 p-4">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center">
                <Music size={32} className="text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
              VUOI LA MUSICA?
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Attiva la playlist hip hop di sottofondo mentre navighi sul sito. 
              Puoi disattivarla in qualsiasi momento.
            </p>
            <div className="flex gap-3 pt-4">
              <button
                onClick={handleDecline}
                className="flex-1 px-4 py-3 rounded bg-gray-700 hover:bg-gray-600 text-white font-bold transition-colors"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                NO, GRAZIE
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 px-4 py-3 rounded bg-red-600 hover:bg-red-700 text-white font-bold transition-colors"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                SÌ, ATTIVA
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Player Spotify Integrato — fissato al bottom */}
      {showPlayer && hasConsented && (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-t border-red-600 shadow-2xl py-2 sm:py-3">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between mb-1 sm:mb-2">
              <div className="flex items-center gap-2">
                <Music size={16} className="text-red-500" />
                <span className="text-white font-bold text-xs sm:text-sm" style={{ fontFamily: 'Oswald, sans-serif' }}>
                  PLAYLIST HIP HOP
                </span>
              </div>
              <button
                onClick={closePlayer}
                className="text-gray-400 hover:text-white transition-colors p-1 rounded hover:bg-gray-800"
                title="Chiudi player"
                aria-label="Chiudi player"
                data-testid="spotify-player-close"
              >
                <X size={18} />
              </button>
            </div>
            <iframe
              src={playlistUrl}
              width="100%"
              height="80"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              className="rounded"
              title="Spotify Playlist - Tecniche Perfette"
              data-testid="spotify-player-iframe"
            />
          </div>
        </div>
      )}

      {/* Pulsante floating per riaprire il player se chiuso */}
      {!showPlayer && hasConsented && (
        <button
          onClick={togglePlayer}
          data-testid="spotify-player-reopen"
          aria-label="Mostra player musicale"
          className="fixed bottom-4 right-4 z-50 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-600 hover:bg-red-700 text-white font-bold text-xs shadow-2xl transition-colors"
          style={{ fontFamily: 'Oswald, sans-serif' }}
        >
          <Music size={16} />
          <span>Riapri Player</span>
        </button>
      )}
    </>
  );
};

export default SpotifyPlayer;
